import packageJson from '../../package.json';

import { BUILD_INFO } from './build-info';

/**
 * Build de desarrollo, el de los previews. Aún no existe la instancia corporativa (TEC-482): sin
 * `API_BASE_URL` apunta al dev de Movilidad, que usa vocabulario universitario. El shell todavía no le
 * pide nada; el primero en hacerlo será TEC-483.
 */
export const environment = {
  production: false,
  version: packageJson.version,
  apiBaseUrl: BUILD_INFO.apiBaseUrl || 'https://dev.admin.tecservice.app/api/v1/',
  /** La galería de componentes (`/galeria`), para QA en el preview. */
  gallery: true,
};
